module.exports = __webpack_public_path__ + "static/media/shape3_0.6b5bc853.obj";